// design-system.md's `PunktValue` — renders a blank's пункт, or the fact
// that it hasn't been distributed to one yet (`null`). Gap, stated on
// purpose: the real `OtkBlank` (`shared`'s `otk-blank.ts`) has no punkt/branch
// field at all yet (`spetsproduktsiya.md`'s proposed `punktRecordId` was
// never added to the real schema — see `lib/warehouse.ts`), so every caller
// passes `null` today and this always renders "Не розподілено." Kept as its
// own component rather than inlined so the printed sheet renders that
// absence as a stated value, not a blank cell, exactly as documented.
export function PunktValue({ punkt }: { punkt: string | null }) {
  if (punkt === null) {
    return <span className="text-muted-foreground">Не розподілено</span>
  }
  return <>{punkt}</>
}
